module.exports = __webpack_public_path__ + "img/7.115d3466.png";